/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Scope_OffersInputs */

const cs_ebr_scope_offers = /** @type {(inputs: Ebr_Scope_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen nabídky`)
};

const en_ebr_scope_offers = /** @type {(inputs: Ebr_Scope_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers only`)
};

/**
* | output |
* | --- |
* | "Offers only" |
*
* @param {Ebr_Scope_OffersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_scope_offers = /** @type {((inputs?: Ebr_Scope_OffersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Scope_OffersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_scope_offers(inputs)
	return cs_ebr_scope_offers(inputs)
});